import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from './auth.service';

const PUBLIC_AUTH_PATHS = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/logout'];

/**
 * Cookie-auth interceptor: access token travels as httpOnly cookie (auto-sent via withCredentials).
 * No manual Bearer header injection needed. On 401 → attempt cookie-based refresh → retry.
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const isPublicAuth = PUBLIC_AUTH_PATHS.some((path) => request.url.includes(path));

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isPublicAuth) {
        return throwError(() => error);
      }
      return auth.refreshAccessToken().pipe(
        switchMap((success) =>
          success
            ? next(request.clone()) // retry — new access cookie already set by refresh
            : throwError(() => error),
        ),
      );
    }),
  );
};
